import { Button } from "@mui/material";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ErrorIcon from '@mui/icons-material/Error';
import { Dispatch, SetStateAction } from 'react';
import { prizeDataType } from "../../pages/EditPromotion/EditPromotionPage";
import { getFlowTabButtons, flowTabButtonsMap } from "../../constants/button-constants";
import { useUser } from "../../providers/UserContext";

type FlowTabButtonsProps = {
    promotionMechanic: string,
    changesDetected?,
    handleConfirmationWindow?,
    tab: string,
    setTab: Dispatch<SetStateAction<string>>,
    prizes?: Array<prizeDataType>,
}

const FlowTabButtons = ({
    promotionMechanic,
    changesDetected,
    handleConfirmationWindow,
    tab,
    setTab,
    prizes,
}: FlowTabButtonsProps) => {
    const { userMaxRole } = useUser();
    return <>
        {
            promotionMechanic && getFlowTabButtons(promotionMechanic, userMaxRole)
                .sort((a, b) => Object.keys(flowTabButtonsMap).indexOf(a) - Object.keys(flowTabButtonsMap).indexOf(b))
                .map(buttonName => (
                    <Button
                        key={buttonName}
                        fullWidth={true}
                        className={tab === buttonName ? 'currentOptionSelected' : ''}
                        onClick={() => { changesDetected ? handleConfirmationWindow(buttonName) : setTab(buttonName) }}>
                        {flowTabButtonsMap[buttonName].label}
                        {(buttonName === 'vouchers' || buttonName === 'winningMoments')
                            && <ErrorOutlineIcon
                                className={tab === buttonName ? "endIcon" : "endIcon-notSelected"}
                                fontSize="medium" />
                        }
                        {(buttonName === 'prizes' && prizes && prizes.length < 1)
                            && <ErrorIcon
                                className={tab === buttonName ? "endIcon" : "endIcon-notSelected"}
                                fontSize="medium" />
                        }
                    </Button>
                ))
        }
    </>
}

export default FlowTabButtons;
